import { getPitchName } from 'bam-node-baseball-savant/utils/pitch-names'
import {
    groupByModal,
    countModal,
    pitchTypeModal,
    teamModal,
    chalOrgModal,
    oppOrgModal,
    shadowZoneModal,
    swingTimingXModal,
    swingTimingYModal,
    swingTimingZModal,
    updateLabel,
    getFlags,
    getMultiSelectValues,
    getAndJoinMultiSelectValues,
} from './multi-select'

export const secondaryGroupHeaders = {
    game_type: {
        name: 'Game<br/>Type',
        field: 'game_type',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center border-left border-right`,
    },
    bat_contact_code: {
        name: 'Contact',
        field: 'bat_contact_code',
        headerClass: `th-component-header align-left th-vertical-bottom`,
        fieldClass: `tr-data align-left border-left border-right`,
        displayFn: (val) => {
            switch (Number(val)) {
                case 2:
                    return 'Hit in Play'
                case 4:
                    return 'Foul'
                case 9:
                    return 'Whiff'
                default:
                    return ''
            }
        },
    },
    bat_position_code: {
        name: 'Batter<br />Pos.',
        field: 'bat_position_code',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center border-left border-right`,
        displayFn: (val) => {
            switch (Number(val)) {
                case 1:
                    return 'P'
                case 2:
                    return 'C'
                case 3:
                    return '1B'
                case 4:
                    return '2B'
                case 5:
                    return '3B'
                case 6:
                    return 'SS'
                case 7:
                    return 'LF'
                case 8:
                    return 'CF'
                case 9:
                    return 'RF'
                case 10:
                    return 'DH'
                case 11:
                    return 'PH'
                default:
                    return ''
            }
        },
    },
    is_game_acceptable: {
        name: 'Acceptable?',
        field: 'is_game_acceptable',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center border-left border-right`,
        displayFn: (val) => (val === 0 ? 'Nope' : 'Yup'),
    },
    api_game_date_month_text: {
        name: 'Month',
        field: 'api_game_date_month_mm',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center border-left border-right`,
        type: 'number',
        isLinkedSort: true,
        displayFn: (_val, { api_game_date_month_text }) =>
            api_game_date_month_text,
    },
    is_hit_into_play_hardhit: {
        name: 'Hard Hit',
        field: 'is_hit_into_play_hardhit',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center border-left border-right`,
        displayFn: (val) => (val === 0 ? 'No' : 'Yes'),
    },
    is_starter_pitcher: {
        name: 'Starter/<br/>Reliever',
        field: 'is_starter_pitcher',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center border-left border-right`,
        displayFn: (val) => (Number(val) === 0 ? 'Reliever' : 'Starter'),
    },
    pitchzone_height_code: {
        name: 'Pitch<br />Height Zone',
        field: 'pitchzone_height_code_num',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center border-left border-right`,
        defaultSortDir: 'asc',
        displayFn: (_val, { pitchzone_height_code }) =>
            pitchzone_height_code || '',
    },
    api_pitch_type_group03: {
        name: 'Pitch<br/>Type',
        field: 'api_pitch_type_group03',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center border-left border-right`,
        displayFn: (val) => {
            if (!val) {
                return '<em>Other</em>'
            }
            return `<span
                    style="display: inline-block; margin: 2px 0"
                    class="search-pitch-label search-pitch-label-${val}"
                    title="${getPitchName(val)}"
                >
                    ${val}
                </span>`
        },
    },
    year: {
        name: 'Year',
        field: 'year',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center border-left border-right`,
        type: 'number',
        hasLinkedSort: true,
        linkedSort: 'api_game_date_month_mm',
    },
    pitch_hand: {
        name: 'Pitch Hand',
        field: 'pitch_hand',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center border-left border-right`,
    },
    bat_side: {
        name: 'Bat Side',
        field: 'bat_side',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center border-left border-right`,
    },
    home_away: {
        name: 'Home/<br />Away',
        field: 'home_away',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center border-left border-right`,
    },
    is_best_speed: {
        name: 'EV50',
        field: 'is_best_speed',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center border-left border-right`,
        displayFn: (val) => (val === 0 ? 'No' : 'Yes'),
    },
    pre_ball_count: {
        name: 'Balls',
        field: 'pre_ball_count',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center border-left border-right`,
    },
    pre_strike_count: {
        name: 'Strikes',
        field: 'pre_strike_count',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center border-left border-right`,
    },
    is_pre_ball_count_3: {
        name: 'Balls',
        field: 'is_pre_ball_count_3',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center border-left border-right`,
        displayFn: (val) => (val === 0 ? '< 3' : '3'),
    },
    is_pre_strike_count_2: {
        name: 'Strikes',
        field: 'is_pre_strike_count_2',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center border-left border-right`,
        displayFn: (val) => (val === 0 ? '< 2' : '2'),
    },
    api_is_pitch_inzone: {
        name: 'In/Out<br />of Zone',
        field: 'api_is_pitch_inzone',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center border-left border-right`,
    },
    gameday3_pitchzone_cd: {
        name: 'Attack<br />Zone',
        field: 'gameday3_pitchzone_cd',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center border-left border-right`,
    },
    abschallenge_breakeven_code: {
        name: 'Chal.<br />Conf. Req.',
        field: 'abschallenge_breakeven_code',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center border-left border-right`,
        displayFn: (val) => val.split('. ')[1],
    },
    is_strike_calc: {
        name: 'In/Out<br />of Zone',
        field: 'is_strike_calc',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center border-left border-right`,
    },
    lineup_cd: {
        name: 'Batter<br />Lineup Slot',
        field: 'lineup_cd',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center border-left border-right`,
    },
    position: {
        name: 'Position',
        field: 'pos_id',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center border-left border-right`,
        displayFn: (val) => {
            switch (val) {
                case 2:
                    return 'C'
                case 3:
                    return '1B'
                case 4:
                    return '2B'
                case 5:
                    return '3B'
                case 6:
                    return 'SS'
                case 7:
                    return 'LF'
                case 8:
                    return 'CF'
                case 9:
                    return 'RF'
                default:
                    return ''
            }
        },
    },
    knee_code: {
        name: 'Catcher<br />Knees<br />(Detail)',
        field: 'knee_code',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center border-left border-right`,
        displayFn: (val) => {
            switch (val) {
                case 1:
                    return 'Both Down'
                case 2:
                    return 'R Up, L Down'
                case 3:
                    return 'L Up, R Down'
                default:
                    return 'Both Up'
            }
        },
    },
    knee_code_overview: {
        name: 'Catcher<br />Knees<br />(Up/Down)',
        field: 'knee_code_overview',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center border-left border-right`,
    },
    timing_x_tiedupflail: {
        name: 'Timing<br/>(Tied Up/Flail)',
        field: 'timing_x_tiedupflail',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center border-left border-right`,
        displayFn: (val) => {
            if (val === 'Tiedup') {
                return 'Tied Up'
            }
            return val
        },
    },
    timing_y_earlylate: {
        name: 'Timing<br/>(Early/Late)',
        field: 'timing_y_earlylate',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center border-left border-right`,
        displayFn: (val) => {
            if (val === 'OnTime') {
                return 'On Time'
            }
            return val
        },
    },
    timing_z_overunder: {
        name: 'Timing<br/>(Over/Under)',
        field: 'timing_z_overunder',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center border-left border-right`,
        displayFn: (val) => {
            if (val === 'Linedup') {
                return 'Lined Up'
            }
            return val
        },
    },
}

function safeGet(id, defaultValue = '') {
    return document.getElementById(id)?.value || defaultValue
}

function getURLParams(extraParams, keysToKeep) {
    const parameters = {
        attackZone: safeGet('ddlAttackZone'),
        batSide: safeGet('ddlBatSide'),
        ballStrike: safeGet('ddlBallStrike'),
        chalOrg: getAndJoinMultiSelectValues(chalOrgModal),
        contactType: safeGet('ddlContactType'),
        count: getAndJoinMultiSelectValues(countModal),
        dateStart: safeGet('ddlDateStart'),
        dateEnd: safeGet('ddlDateEnd'),
        gameType: safeGet('ddlGameType'),
        groupBy: getMultiSelectValues(groupByModal).slice(0, 4).join('|'),
        isHardHit: safeGet('ddlIsHardHit'),
        minSwings: safeGet('ddlMinSwings'),
        minGroupSwings: safeGet('ddlMinGroupSwings'),
        oppOrg: getAndJoinMultiSelectValues(oppOrgModal),
        pitchHand: safeGet('ddlPitchHand'),
        pitchType: getAndJoinMultiSelectValues(pitchTypeModal),
        seasonStart: safeGet('ddlSeasonStart'),
        seasonEnd: safeGet('ddlSeasonEnd'),
        shadowZones: getAndJoinMultiSelectValues(shadowZoneModal),
        swingTimingX: getAndJoinMultiSelectValues(swingTimingXModal),
        swingTimingY: getAndJoinMultiSelectValues(swingTimingYModal),
        swingTimingZ: getAndJoinMultiSelectValues(swingTimingZModal),
        team: getAndJoinMultiSelectValues(teamModal),
        type: safeGet('ddlType'),
        ...getFlags(),
        ...extraParams,
    }

    const filteredParams = Object.fromEntries(
        Object.entries(parameters).filter(
            ([key, value]) => value !== '' || keysToKeep.includes(key)
        )
    )

    return filteredParams
}

export function populateUrl(extraParams = {}, keysToKeep = []) {
    const parameters = getURLParams(extraParams, keysToKeep)
    const currentParams = new URLSearchParams(window.location.search)
    if (currentParams.get('sortColumn')) {
        parameters.sortColumn = currentParams.get('sortColumn')
    }
    if (currentParams.get('sortDirection')) {
        parameters.sortDirection = currentParams.get('sortDirection')
    }
    const urlParams = new URLSearchParams(parameters)

    return `${window.location.pathname}?${urlParams.toString()}`
}

export function populateInitialFilters() {
    // Update counts for multi-select
    document.querySelectorAll('.savant-multi-select-modal').forEach((el) => {
        updateLabel(el)
    })
}

// I _think_ this makes sense to always call, but it's possible it will be timed wrong
populateInitialFilters()
